module.exports = __webpack_public_path__ + "static/driver2-f3dd92756b938ca498d31c5416c13837.jpg";